import { render } from "./ProductImport.vue?vue&type=template&id=7997e395&ts=true"
import script from "./ProductImport.vue?vue&type=script&lang=ts"
export * from "./ProductImport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__